import { FC } from 'react'
import { TextField, MenuItem } from '@mui/material'
import { useFetchAllAccountsQuery } from '../../../../generated'
import { GRAPHQL_QUERY_POLICY } from '../../../constants'

interface BankAccountFilterProps {
  bankAccountId: string | undefined
  setReportFilters: React.Dispatch<React.SetStateAction<Record<string, any>>>
}

const BankAccountFilter: FC<BankAccountFilterProps> = ({ bankAccountId, setReportFilters }) => {
  const { data, loading } = useFetchAllAccountsQuery({
    ...GRAPHQL_QUERY_POLICY,
    variables: {
      accountsInput: {
        isBankAccount: true,
        active: true
      }
    }
  })

  const accounts = data?.fetchAllAccounts?.accounts || []

  return (
    <TextField
      select
      label="Bank Account"
      value={bankAccountId || ''}
      onChange={e => setReportFilters(prev => ({ ...prev, bankAccountId: e.target.value }))}
      sx={{ minWidth: 250 }}
      disabled={loading}
    >
      <MenuItem value="">-- All Banks --</MenuItem>
      {accounts.map(account =>
        account ? (
          <MenuItem key={account.id} value={account.id}>
            ({account.sortCode}) {account.name}
          </MenuItem>
        ) : null
      )}
    </TextField>
  )
}

export default BankAccountFilter
